import React from 'react';

const Title = ({title}) => {
  return (
    <div className="col-lg-12">
      <hr />
      <h2 className="intro-text text-center">{title}
      </h2>
      <hr />
    </div>
  );
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/title.js